export default "__VITE_ASSET__a944580d__"